import React, { useState, useEffect } from 'react';
import { Form, Button, InputGroup, Spinner } from 'react-bootstrap';
import { Input } from '../shared';
import { useLogin } from '../../context/LoginContext';
import { useNavigate } from 'react-router-dom';
import { EyeLessIcon, ResetIcon, ViewIcon } from '../../utils/FontIcon';
import { isNotEmpty, isValidNumber, isValidMobileNumber, hasGraterthenLength, hasSpecificLength } from '../../utils/validation';
import apiClient from '../../api/apiClient';
import { GETCAPTCHA, REFRESHCAPTCHA } from '../../utils/ApiEndPoint';
function LoginForm() {
    const navigate = useNavigate();
    const { login } = useLogin();
    const [form, setForm] = useState({
        mobileno: "",
        password: "",
        showPassword: false,
        rememberMe: false,
        sessionId: '',
        captchaCode: ''
    });
    const [captchaImage, setCaptchaImage] = useState('');
    const [errors, setErrors] = useState({});
    const [loginStatus, setLoginStatus] = useState('');
    const [waitForResponse, setWaitForResponse] = useState(false);
    const genrateCaptcha = () => {
        apiClient.post(GETCAPTCHA)
            .then((response) => {
                // console.log("🚀 krishna  ~ response:", response);
                if (response.status === 200) {
                    setCaptchaImage(response.data?.svg || '');
                    setForm((prev) => ({
                        ...prev,
                        sessionId: response.data?.sessionId || '',
                    }));
                }
            })
            .catch((err) => {
                console.log("🚀 krishna  ~ err:", err);
            });
    }
    useEffect(() => {
        genrateCaptcha();
    }, []);
    const handleLogIn = (e) => {
        e.preventDefault();
        if (validate()) {
            setWaitForResponse(true);
            login({
                mobile: form.mobileno,
                password: form.password,
                rememberMe: form.rememberMe,
                sessionId: form.sessionId,
                captchaCode: form.captchaCode
            }, handelRresponse);
        };

    };
    const handelRresponse = (response) => {
        setWaitForResponse(false);
        if (response.status === 'error') {
            setLoginStatus(response.message);
            setForm((prev) => ({
                ...prev,
                password: '',
                captchaCode: ''
            }));
            genrateCaptcha();
            return;
        }
        // If login is successful, navigate to home
        setForm({
            mobileno: "",
            password: "",
            showPassword: false,
            rememberMe: false,
            sessionId: "",
            captchaCode: ""

        });
        setLoginStatus('')
        setErrors({});
        navigate('/home')
    };
    const validate = () => {
        const newErrors = {};
        if (!isNotEmpty(form.mobileno)) newErrors.mobileno = "Mobiel Number is required";
        else if (!isValidNumber(form.mobileno)) newErrors.mobileno = "Mobile Number is not valid";
        else if (!isValidMobileNumber(form.mobileno)) newErrors.mobileno = "Mobile Number should start with 6,7,8 or 9";
        else if (!hasSpecificLength(form.mobileno, 10)) newErrors.mobileno = "Mobile Number should be 10 digits";
        if (!isNotEmpty(form.password)) newErrors.password = "Password is required";
        if (!isNotEmpty(form.captchaCode)) newErrors.captchaCode = "Captcha is required";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        } else {
            setErrors({});
            return true;
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'mobileno' && (!isValidNumber(value) || hasGraterthenLength(value, 10))) {
            return;
        }
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({ ...prev, [name]: undefined }));
        setLoginStatus('');
    };
    const refreshCaptcha = () => {
        const data = {
            sessionId: form.sessionId,
        }
        apiClient.post(REFRESHCAPTCHA, data)
            .then((response) => {
                if (response.status === 200) {
                    setCaptchaImage(response.data?.svg || '');
                    setForm((prev) => ({
                        ...prev,
                        sessionId: response.data?.sessionId || '',
                        captchaCode: ''
                    }));
                }
            })
            .catch((err) => {
                console.log("🚀 krishna  ~ err:", err);
            });
    };
    return (
        <div className="bg-white shadow mx-auto login-bg" style={{ borderRadius: '10px 60px 60px 60px' }}>
            <h2 className="fw-bold mb-4">Login</h2>
            <Form onSubmit={handleLogIn}>
                <Input
                    label="Mobile No"
                    isMandetory={true}
                    name="mobileno"
                    type="text"
                    value={form.mobileno}
                    onChange={handleChange}
                    placeholder="enter your mobile no"
                    isInvalid={!!errors.mobileno}
                    feedback={errors.mobileno}
                    inlineFeedback={true}
                    maxLength={80}
                />

                <Form.Group className="mb-3 mt-4 p-relative" controlId="formPassword">
                    <Form.Label className='label'>Password</Form.Label>
                    <Form.Label className='label' style={{ zIndex: '100' }}>
                        {'Password'}
                        <span className="redtxt">*</span>
                    </Form.Label>
                    <InputGroup>
                        <Form.Control
                            type={form.showPassword ? 'text' : 'password'}
                            placeholder="XXXXXXXXXX"
                            name='password'
                            value={form.password}
                            onChange={handleChange}
                        />
                        <Button
                            variant="outline-secondary"
                            onClick={() =>
                                setForm((prev) => ({
                                    ...prev,
                                    showPassword: !form.showPassword,
                                }))}
                            // onMouseUp={() =>
                            //     setForm((prev) => ({
                            //         ...prev,
                            //         showPassword: false,
                            //     }))}
                            tabIndex={-1}
                        >
                            {form.showPassword ? <ViewIcon /> : <EyeLessIcon />}
                        </Button>
                    </InputGroup>
                    {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
                </Form.Group>

                <Input
                    label="Captcha"
                    isMandetory={true}
                    name="captchaCode"
                    type="text"
                    value={form.captchaCode}
                    onChange={handleChange}
                    placeholder="enter captchaCode"
                    isInvalid={!!errors.captchaCode}
                    feedback={errors.captchaCode}
                    inlineFeedback={true}
                    maxLength={80}
                />
                <div className="d-flex justify-content-center align-items-center mb-3">
                    <div dangerouslySetInnerHTML={{ __html: captchaImage }} style={{ width: '180px' }} />
                    <span style={{ cursor: 'pointer' }} onClick={refreshCaptcha}><ResetIcon style={{ fontSize: '22px' }}></ResetIcon></span>
                </div>
                <Button
                    variant="warning"
                    type="submit"
                    title='Login'
                    className="w-100 mb-3 save-btn"
                    disabled={waitForResponse}
                >
                    LOGIN
                </Button>

                      <p className='text-center'> New User?          
                <a className='d-inline ms-1' onClick={(e) => { navigate("/register"); }} style={{ cursor: 'pointer',color: '#f26522', textDecoration:'underline'}}>
                    Create Acount
                </a>
                    </p>
                {loginStatus && (
                    <div className="text-danger mt-2" style={{ fontSize: 14 }}>
                        {loginStatus}
                    </div>
                )}
            </Form>
        </div>
    );
}

export default LoginForm;